import { regex } from "react-admin";

export const intRegex = regex(
  /^\d+$/,
  "resources.notifications.errors.invalid_syntax"
);

export const validateTextInput = regex(
  /^(?!\s).*/,
  "resources.notifications.errors.invalid_syntax"
);
